// extracted by mini-css-extract-plugin
export default {"container":"SetNameProject_container__F+JxO"};